// Use this if you want TypeScript to verify that a switch statement
// exhaustively covers all branches of e.g. an enum type
// Lifted from https://stackoverflow.com/a/52913382/74152
export class UnreachableCaseError extends Error {
  constructor(val: never | string) {
    super(`Unreachable case: ${val}`);
  }
}
